import { styled } from '@mui/material/styles';
import { Typography } from '../../Typography';
import { CircularProgress } from '../CircularProgress';

export const WrapperStyled = styled('div')<{ $size: number }>`
  position: relative;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
`;

export const CircularProgressBackgroundStyled = styled(CircularProgress)`
  position: absolute;
  top: 0;
  left: 0;

  circle {
    stroke: ${({ theme }) => theme.palette.progressCircularWithValue.main};
  }
`;

export const CircularProgressStyled = styled(CircularProgress)`
  position: absolute;
  top: 0;
  left: 0;
  stroke-linecap: round;

  circle {
    stroke: ${({ theme }) => theme.palette.progressCircularWithValue.mainFilled};
  }
`;

export const ValueStyled = styled(Typography)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
